//categories and subcategories
if (window.location.pathname == "/collections/earrings") {
    document.querySelector("#collectionSortEarrings").classList.add("active");
    document.querySelector(`#collectionSortCategoryDropdown > [value="Earring"]`).classList.add("active");
    document.querySelector(`#collectionSortMobileCategory > [value="Earring"]`).classList.add("active", "default");
} else if (window.location.pathname == "/collections/charms") {
    document.querySelector(`#collectionSortCategoryDropdown > [value="Charm"]`).classList.add("active");
    document.querySelector(`#collectionSortMobileCategory > [value="Charm"]`).classList.add("active", "default");
} else if (window.location.pathname == "/collections/chains") {
    document.querySelector("#collectionSortChains").classList.add("active");
    document.querySelector(`#collectionSortCategoryDropdown > [value="Chain"]`).classList.add("active");
    document.querySelector(`#collectionSortMobileCategory > [value="Chain"]`).classList.add("active", "default");
} else if (window.location.pathname == "/collections/necklaces") {
    document.querySelector("#collectionSortNecklaces").classList.add("active");
    document.querySelector(`#collectionSortCategoryDropdown > [value="Necklace"]`).classList.add("active");
    document.querySelector(`#collectionSortMobileCategory > [value="Necklace"]`).classList.add("active", "default");
} else if (window.location.pathname == "/collections/rings") {
    document.querySelector("#collectionSortRings").classList.add("active");
    document.querySelector(`#collectionSortCategoryDropdown > [value="Ring"]`).classList.add("active");
    document.querySelector(`#collectionSortMobileCategory > [value="Ring"]`).classList.add("active", "default");
} else if (window.location.pathname == "/collections/bracelets") {
    document.querySelector("#collectionSortBracelets").classList.add("active");
    document.querySelector(`#collectionSortCategoryDropdown > [value="Bracelet"]`).classList.add("active");
    document.querySelector(`#collectionSortMobileCategory > [value="Bracelet"]`).classList.add("active", "default");
}

/**
 * Fetches all the products in a given collection.
 * @param collectionHandle Handle of the collection
 * @returns Array of all products in the collection
 */
async function getAllCollectionProducts(collectionHandle) {
    // get all products
    const productCountResponse = await fetch(`/collections/${collectionHandle}/?view=json-product-count`)
        .then(res => res.json())

    // pull out total products
    const totalProducts = productCountResponse.product_count;

    // calculate total pages we need to fetch given there's 250 per page
    const productsPerPage = 250;
    const totalPages = Math.ceil(totalProducts / productsPerPage);

    // object to hold all products based on index
    let allProducts = {}

    // fetch all pages at once
    const fetchPromises = [];
    for (let page = 1; page <= totalPages; page++) {
        fetchPromises.push(
            fetch(`/collections/${collectionHandle}/?view=json-feed&page=${page}`)
                .then(res => res.json())
                .then(products => {
                    allProducts[page] = products;
                })
        );
    }

    // wait for all fetches to complete
    await Promise.all(fetchPromises);

    // create array to make sure we maintain order
    let allProductsArray = [];
    for (let page = 1; page <= totalPages; page++) {
        allProducts[page].forEach(product => {
            allProductsArray.push(product);
        })
    }

    // return array
    return allProductsArray;
}

/******************
 Return min and max of productsIn
 ******************/
function returnMinMax(productsIn) {
    let localMin, localMax;
    productsIn.forEach(function (product) {
        product.variants.forEach(function (variant) {
            //for the first variant we set the value of min and max
            if (localMin == undefined) {
                localMin = variant.price;
                localMax = variant.price;
            } else {
                if (variant.price < localMin) {
                    localMin = variant.price;
                } else if (variant.price > localMax) {
                    localMax = variant.price;
                }
            }
        });
    });

    //there are no products
    if (localMin == undefined) {
        return [0, 100];
    }

    //there is only one price
    if (localMin == localMax) {
        localMax += 100;
    }

    return [Math.round(localMin / 100), Math.round(localMax / 100)];
}

/******************
 desktop/mobile productArray filter
 productsIn is either products or productsAll
 if it's productsAll returnProductCount will be true and is used only on the mobile filter page
 ******************/
function filterProducts(productsIn, returnProductCount) {

    //scope variables
    let filters = {
        category: [],
        subcategory: [],
        color: [],
        gem: [],
        inStockOnly: false,
        sortBy: false,
        range: [],
        page: page
    }

    //we need to gather the differnt filters we are applying to the array
    if (window.innerWidth > 950) {

        //catagory
        document.querySelectorAll("#collectionSortCategoryDropdown > div.active").forEach(function (element) {
            filters.category.push(element.getAttribute("value"));
        });
        //sub (only look at the ACTIVE subcategory divs)
        document.querySelectorAll(".collectionSortSubcategory.active div.active").forEach(function (element) {
            filters.subcategory.push(element.getAttribute("value"));
        });
        //color
        document.querySelectorAll("#collectionSortColorSelector > div.active").forEach(function (element) {
            filters.color.push(element.getAttribute("value"));
        });
        //gems
        document.querySelectorAll("#collectionSortGemDropdown > div.active").forEach(function (element) {
            filters.gem.push(element.getAttribute("value"));
        });
        //in stock
        if (document.querySelector("#collectionSortInStock > input").checked) {
            filters.inStockOnly = true;
        }
        //sort by
        document.querySelectorAll("#collectionSortByDropdown > div.active").forEach(function (element) {
            filters.sortBy = element.getAttribute("value");
        });
        //range
        filters.range = desktopSlider.get();

    } else {

        //catagory
        document.querySelectorAll("#collectionSortMobileCategory > div.active").forEach(function (element) {
            filters.category.push(element.getAttribute("value"));
        });
        //sub (only look at the ACTIVE subcategory divs)
        document.querySelectorAll(".collectionSortMobileSubcategory.active div.active").forEach(function (element) {
            filters.subcategory.push(element.getAttribute("value"));
        });
        //color
        document.querySelectorAll("#collectionSortMobileColor > div.active").forEach(function (element) {
            filters.color.push(element.getAttribute("value"));
        });
        //gems
        document.querySelectorAll("#collectionSortMobileGems > div.active").forEach(function (element) {
            filters.gem.push(element.getAttribute("value"));
        });
        //in stock
        if (document.querySelector("#collectionSortMobileInStock").checked) {
            filters.inStockOnly = true;
        }
        //sort by
        if (document.querySelector("#collectionSortMobileSort > select").value != 0) {
            filters.sortBy = document.querySelector("#collectionSortMobileSort > select").value;
        }
        //range
        filters.range = mobileSlider.get();

    }

    //ok, the hard part, we need to sort the array based on the above variables and run the appendProducts function
    let filteredProducts = [];

    //first part is to narrow down the array before sorting it (if sory by price is selected)
    productsIn.forEach(function (product, index) {
        //this must be true at the end to be appended as a valid product
        let validProduct = true;

        //check for category (product type)
        if (filters.category.length > 0) {
            if (findOne(product.type, filters.category) == false) {
                validProduct = false;
            }
        }

        //check for subcategory
        //this only applies if the catagory (product type) is either Earrings, Necklaces, Ring or Bracelets
        //Chains (Length) DO NOT APPLY as those are variants not product tags
        if (filters.category.includes("Earring") || filters.category.includes("Necklace") || filters.category.includes("Ring") || filters.category.includes("Bracelet")) {
            if (filters.subcategory.length > 0 && validProduct == true) {
                if (findOne(product.tags, filters.subcategory) == false) {
                    validProduct = false;
                }
            }
        }

        // NOTE this is now variant specfic, before this it was general product info
        // now that we've elimited the products that are not in the same category and subcategory (if earring or necklace)
        // we need to cycle through all the variants and check if they meet the following criteria
        // 1) If the category is Chain there needs to a variant that has the option
        // 2) Check for a matching color and find a variant that has that option
        // 3) Check for a matching gem and find a variant that has that options
        // 4) Check that the variant is in stock
        // 5) Check that price is within the range
        // 6) Once we find a valid variant we set product.correctVariant to the correct variant object which will be referenced when appeneded
        if (validProduct == true) {
            for (let i = 0; i < product.variants.length; i++) {
                //this must be true at the end to be appended as a valid product
                let validVariant = true;

                //check for subcategory variant
                if (filters.category.includes("Chain")) {
                    if (filters.subcategory.length > 0 && validVariant == true) {
                        if (findOne(product.variants[i].options, filters.subcategory) == false) {
                            validVariant = false;
                        }
                    }
                }

                //check for color variant
                if (filters.color.length > 0 && validVariant == true) {
                    if (findOne(product.variants[i].options, filters.color) == false) {
                        validVariant = false;
                    }
                }

                //check for gem variant
                if (filters.gem.length > 0 && validVariant == true) {
                    if (findOne(product.variants[i].options, filters.gem) == false) {
                        validVariant = false;

                        //if there is NOT a match between the variant options there is one more chance for this product to be valid
                        //if there is a match between the product tags and gems
                        if (findOne(product.tags, filters.gem) == true) {
                            validVariant = true;
                        }

                        // one other option, if one of the gems is "Pearl", we broadly check if the variant options include "Mother of Pearl" or "Pearl"
                        // this is a bit of a hack but it works for now
                        if (filters.gem.includes("Pearl") && (product.variants[i].options.includes("Mother of Pearl") || product.variants[i].options.includes("Pearl") || product.options.find(option => option.name.includes("Pearl")))) {
                            validVariant = true;
                        }
                    }
                }

                //check for inventory of variant
                if (filters.inStockOnly == true && validVariant == true) {
                    if (product.variants[i].inventory < 1) {
                        validVariant = false;
                    }
                }

                //check that this variant is within the price range
                //note the price range is not set when ignoreRange is defined thus making it an empty array
                if (filters.range.length > 0 && validVariant == true) {
                    if (product.variants[i].price / 100 < filters.range[0] || product.variants[i].price / 100 > filters.range[1]) {
                        validVariant = false;
                    }
                }

                //as long as the variant is still valid it gets appeneded to the filteredProducts array and the correct variant is set as product.correctVariant
                //product.correctVariant is later used in the appendProducts product
                if (validVariant == true) {
                    product.correctVariant = product.variants[i];
                    filteredProducts.push(product);
                    break;
                }
            }
        }


        //before we go to the next product, we are going to check if we need to override the found variant based on the selected filters
        // we are allowing in stock to be shown as long as no variant specific filters have been applied such as color, gem, chain length.
        //we change the correct variant to a variant that is IN STOCK ONLY IF BOTH ARE TRUE
        // 1) there are no gems or colors filters
        // 2) we are on the chains page, the subcategory length is not a current filter
        let findNewVariant = true;
        if (filters.color.length > 0 || filters.gem.length > 0) {
            findNewVariant = false;
        } else if (collectionTitle == "Chains" && filters.subcategory.length > 0) {
            findNewVariant = false;
        }

        if (findNewVariant) {
            for (let i = 0; i < product.variants.length; i++) {
                if (product.variants[i].inventory > 0) {
                    product.correctVariant = product.variants[i];
                    break;
                }
            }
        }

        // if we're on the the-pearl-edit collection, we show the variant with a option as Mother of Pearl OR the Pearl AND there are no other filters
        if (collectionTitle == "The Pearl Edit" && filters.color.length === 0 && filters.gem.length === 0) {
            for (let i = 0; i < product.variants.length; i++) {
                if (product.variants[i].options.includes("Mother of Pearl") || product.variants[i].options.includes("Pearl")) {
                    product.correctVariant = product.variants[i];
                    break;
                }
            }
        }

    });

    //check if they need to be sorted
    //low to high
    if (filters.sortBy == "LH") {
        let sortCompleted = false;
        while (sortCompleted == false) {
            sortCompleted = true;
            for (let i = 0; i < filteredProducts.length - 1; i++) {
                if (filteredProducts[i].correctVariant.price > filteredProducts[i + 1].correctVariant.price) {
                    //temp variables
                    let temp1 = filteredProducts[i];
                    let temp2 = filteredProducts[i + 1];
                    //swap products
                    filteredProducts[i] = temp2;
                    filteredProducts[i + 1] = temp1;
                    //needs to be sorted again
                    sortCompleted = false;
                }
            }
        }
    }
    //high to low
    else if (filters.sortBy == "HL") {
        let sortCompleted = false;
        while (sortCompleted == false) {
            sortCompleted = true;
            for (let i = 0; i < filteredProducts.length - 1; i++) {
                if (filteredProducts[i].correctVariant.price < filteredProducts[i + 1].correctVariant.price) {
                    //temp variables
                    let temp1 = filteredProducts[i];
                    let temp2 = filteredProducts[i + 1];
                    //swap products
                    filteredProducts[i] = temp2;
                    filteredProducts[i + 1] = temp1;
                    //needs to be sorted again
                    sortCompleted = false;
                }
            }
        }
    }

    //if returnProductCount is true, return the filtered products array
    //console.log(filteredProducts);
    if (returnProductCount == true) {
        return filteredProducts.length;
    } else {
        //if savedFilter is false we set the page number to the default of 1 otherwise we don't touch it
        if (savedFilters) {
            savedFilters = false;
        } else {
            page = 1;
        }
        //set filter object as hash
        window.location.hash = encodeURIComponent(JSON.stringify(filters));
        //append products
        appendProducts(filteredProducts);
    }

}

/******************
 event listener for all filters
 ******************/
function setupFilters() {
    /******************
     DESKTOP
     ******************/

    //open sort drop down
    document.querySelectorAll(".collectionSortTitle").forEach(function (element) {
        //first check if there is a dropdown sibling (color and instock only dont have one)
        let dropdown = element.nextElementSibling;
        if (dropdown.classList.contains("collectionSortDropDown")) {
            element.addEventListener("click", function (e) {
                //check if the drop down is already open so they're clicking on the title to close it
                if (dropdown.classList.contains("open")) {
                    document.querySelector(".collectionSortDropDown.open").classList.remove("open");
                } else {
                    //timeout as since this needs to run AFTER the close drop down (body event listner is going to fire as well)
                    setTimeout(function () {
                        dropdown.classList.add("open");
                    }, 10);
                }
            });
        }
    });

    //close drop down
    document.querySelector("body").addEventListener("click", function (e) {
        //check if drop down is open and the class stayOpen is NOT present
        if (document.querySelector(".collectionSortDropDown.open") && e.target.closest(".stayOpen") == null) {
            document.querySelector(".collectionSortDropDown.open").classList.remove("open");
        }
    });

    //category, subcategory, gem
    document.querySelectorAll(".collectionSortDropDown:not(#collectionSortByDropdown) > div").forEach(function (element) {
        element.addEventListener("click", function () {
            //on normal collections only allow a single category to be selected
            if (collectionType == "" && this.parentElement == document.querySelector("#collectionSortCategoryDropdown")) {
                //if it's already active, redirect to the shop all page otheriwse to what is selected
                window.location.href = (this.classList.contains("active")) ? "/collections/all" : this.textContent.toLowerCase();
            } else {
                if (this.classList.contains("active")) {
                    this.classList.remove("active");
                } else {
                    this.classList.add("active");
                }
            }
            updateLabels();
            filterProducts(products);
        });
    });

    //color filter
    document.querySelectorAll("#collectionSortColorSelector > div").forEach(function (element) {
        element.addEventListener("click", function () {
            if (this.classList.contains("active")) {
                this.classList.remove("active");
            } else {
                this.classList.add("active");
            }
            filterProducts(products);
        });
    });

    //color hover
    document.querySelectorAll(`#collectionSortColorSelector > div[value]`).forEach(function (element) {
        //mosue on
        element.addEventListener("mouseover", function () {
            this.insertAdjacentHTML("beforeend", `<div id="colorOptionHover">${this.getAttribute("value")}</div>`);
        });
        //mouse off
        element.addEventListener("mouseout", function () {
            document.querySelector("#colorOptionHover").remove();
        });
    });

    //instock only filter
    document.querySelector("#collectionSortInStock > input").addEventListener("click", function () {
        filterProducts(products);
    });

    //sort by filter
    document.querySelectorAll("#collectionSortByDropdown > div").forEach(function (element) {
        element.addEventListener("click", function () {
            //only allow one to be selected at a time
            if (this.classList.contains("active")) {
                this.classList.remove("active");
            } else {
                //check if one is already selected and if so remove the active class
                if (document.querySelector("#collectionSortByDropdown > div.active")) {
                    document.querySelector("#collectionSortByDropdown > div.active").classList.remove("active")
                }
                this.classList.add("active");
            }
            filterProducts(products);
        });
    });


    /******************
     MOBILE
     ******************/

    //open filter
    document.querySelector("#collectionSortMobileFilter").addEventListener("click", function () {
        document.querySelector("#collectionSortMobilePage").open();
    });

    //clear filter
    document.querySelector("#collectionSortMobileCancel").addEventListener("click", function () {
        //remove all active categories
        document.querySelectorAll("#collectionSortMobileCategory > div.active").forEach(function (element) {
            element.classList.remove("active");
        });

        //set defualt category to active
        document.querySelectorAll("#collectionSortMobileCategory > div.default").forEach(function (element) {
            element.classList.add("active");
        });

        //reset subcategory container
        document.querySelectorAll(".collectionSortMobileSubcategory.active").forEach(function (element) {
            element.classList.remove("active");
            element.querySelectorAll("div.active").forEach(function (element) {
                element.classList.remove("active");
            })
        });

        //remove all active colors
        document.querySelectorAll("#collectionSortMobileColor > div").forEach(function (element) {
            element.classList.remove("active");
        });

        //remove all active gems
        document.querySelectorAll("#collectionSortMobileGems > div").forEach(function (element) {
            element.classList.remove("active");
        });

        //reset stock
        document.querySelector("#collectionSortMobileInStock").checked = false;

        //reset range
        mobileSlider.set([min, max]);

        //update labels
        updateLabels();

        //apply filter
        // this attribute is added when quick menu is applied, otherwise we'd be filtering products twice
        if (this.getAttribute("dontFilterProducts") == null) {
            filterProducts(products);
        }
    });

    //apply filter
    document.querySelector("#collectionSortMobileApply").addEventListener("click", function () {
        if (collectionType == "") {
            //before we apply filter, need to determine if a redirect is needed
            //we only need to redirect if the page we are on is different from the selected category AND we are NOT on SHOP page
            let activeCategory = "noMatch";
            if (document.querySelector("#collectionSortMobileCategory > div.active")) {
                activeCategory = document.querySelector("#collectionSortMobileCategory > div.active").textContent;
            } else if (collectionTitle == "Shop All") {
                activeCategory = "Shop All";
            }

            if (collectionTitle != activeCategory) {
                let redirectFilters = {
                    category: [],
                    subcategory: [],
                    color: [],
                    gem: [],
                    inStockOnly: false,
                    sortBy: false,
                    range: []
                }
                //category
                document.querySelectorAll("#collectionSortMobileCategory > div.active").forEach(function (element) {
                    redirectFilters.category.push(element.getAttribute("value"));
                });
                //sub (only look at the ACTIVE subcategory divs)
                document.querySelectorAll(".collectionSortMobileSubcategory.active div.active").forEach(function (element) {
                    redirectFilters.subcategory.push(element.getAttribute("value"));
                });
                //color
                document.querySelectorAll("#collectionSortMobileColor > div.active").forEach(function (element) {
                    redirectFilters.color.push(element.getAttribute("value"));
                });
                //gem
                document.querySelectorAll("#collectionSortMobileGems > div.active").forEach(function (element) {
                    redirectFilters.gem.push(element.getAttribute("value"));
                });
                //in stock
                if (document.querySelector("#collectionSortInStock > input").checked == true || document.querySelector("#collectionSortMobileInStock").checked == true) {
                    redirectFilters.inStockOnly = true;
                }
                //price range
                redirectFilters.range = mobileSlider.get();

                //redirect
                //if no category selected go to shop all, otherwise active category
                if (document.querySelectorAll("#collectionSortMobileCategory > div.active").length == 0) {
                    window.location.href = `/collections/all#${encodeURIComponent(JSON.stringify(redirectFilters))}`;
                } else {
                    window.location.href = `/collections/${document.querySelector("#collectionSortMobileCategory > div.active").textContent.toLowerCase()}#${encodeURIComponent(JSON.stringify(redirectFilters))}`;
                }
            } else {
                document.querySelector("#collectionSortMobilePage").close();
                filterProducts(products);
            }
        } else if (collectionType == "broad") {
            document.querySelector("#collectionSortMobilePage").close();
            filterProducts(products);
        }
    });

    //category, subcategories, gems
    document.querySelectorAll(".collectionSortMobileBodyGrid > div[value]").forEach(function (element) {
        element.addEventListener("click", function () {

            //normal collection page when a category is clicked
            if (collectionType == "" && this.parentElement == document.querySelector("#collectionSortMobileCategory")) {
                //reset subcategory container
                document.querySelectorAll(".collectionSortMobileSubcategory.active").forEach(function (element) {
                    element.classList.remove("active");
                    element.querySelectorAll("div.active").forEach(function (element) {
                        element.classList.remove("active");
                    })
                });
                //only allow a single cateogry to be selected (when of course we're not clicking itself)
                if (document.querySelector("#collectionSortMobileCategory > div.active") && this != document.querySelector("#collectionSortMobileCategory > div.active")) {
                    document.querySelector("#collectionSortMobileCategory > div.active").classList.remove("active")
                }
            }

            //if it's already active, unselect it
            if (this.classList.contains("active")) {
                this.classList.remove("active");
            } else {
                //on normal collections only allow a single category to be selected
                this.classList.add("active");
            }

            updateLabels();

        })
    })

    //color filter
    document.querySelectorAll("#collectionSortMobileColor > div[value]").forEach(function (element) {
        element.addEventListener("click", function () {
            if (this.classList.contains("active")) {
                this.classList.remove("active");
            } else {
                this.classList.add("active");
            }
            updateLabels();
        });
    });

    //instock filter
    document.querySelector("#collectionSortMobileInStock").addEventListener("click", function () {
        updateLabels();
    });

    //sort by filter
    document.querySelector("#collectionSortMobileSort > select").addEventListener("change", function () {
        filterProducts(products);
    });

}

/******************
 update labels
 ******************/
function updateLabels() {
    /******************
     DESKTOP
     ******************/
    //category, subcategory, gem
    document.querySelectorAll(".collectionSortDropDown:not(#collectionSortByDropdown)").forEach(function (element) {
        let activeElements = element.querySelectorAll("div.active");
        let labelElement = element.parentElement.querySelector(".collectionSortTitle > span");
        if (activeElements.length == 0) {
            labelElement.textContent = "All";
        } else {
            let label = "";
            activeElements.forEach(function (element, index) {
                //check if index is greater than 1 and if so add 3 trailing dots at the end of the label
                if (index == 0) {
                    label += element.textContent;
                } else if (index == 1) {
                    label += `, ${element.textContent}`;
                } else if (index == 2) {
                    label += `, ...`;
                }
            });
            labelElement.textContent = label;
        }
    });

    /******************
     MOBILE
     ******************/

    //category, subcategory, gem
    document.querySelectorAll(".collectionSortMobileBodyGrid").forEach(function (element) {
        //on normal collections, since you can only select 1 category should not be updated
        if (element != document.querySelector("#collectionSortMobileCategory")) {
            //update count
            let activeElements = element.querySelectorAll("div.active");
            let labelElement = element.parentElement.querySelector(".collectionSortMobileBodyTitle");
            if (activeElements.length == 0) {
                labelElement.textContent = labelElement.getAttribute("label");
            } else {
                labelElement.textContent = `${labelElement.getAttribute("label")} (${activeElements.length})`;
            }
        }
    });


    //color filter
    document.querySelectorAll("#collectionSortMobileColor > div[value]").forEach(function (element) {
        //update count
        let totalColors = document.querySelectorAll("#collectionSortMobileColor > div.active").length;
        if (totalColors == 0) {
            document.querySelector("#collectionSortMobileColorTitle").textContent = `Color`;
        } else {
            document.querySelector("#collectionSortMobileColorTitle").textContent = `Color (${totalColors})`;
        }
    });

    //update desktop labels
    let desktopRange = desktopSlider.get();
    document.querySelector("#desktopSliderMin").textContent = `${price(desktopRange[0] * 100)}`;
    document.querySelector("#desktopSliderMax").textContent = `${price(desktopRange[1] * 100)}`;
    //update mobile labels
    let mobileRange = mobileSlider.get();
    document.querySelector("#mobileSliderMin").textContent = `${price(mobileRange[0] * 100)}`;
    document.querySelector("#mobileSliderMax").textContent = `${price(mobileRange[1] * 100)}`;
    //update mobile title label
    document.querySelector("#collectionSortMobileRangeTitle").textContent = (mobileSlider.get()[0] == min && mobileSlider.get()[1] == max) ? "Price Range" : "Price Range (1)";


    //update mobile sort page
    if (window.innerWidth < 950) {
        let totalFilters = 0;
        //subcategory is only applicable on a normal collection page
        if (collectionType == "") {
            totalFilters += document.querySelectorAll(".collectionSortMobileSubcategory active div.active").length;
            totalFilters += document.querySelectorAll("#collectionSortMobileColor > div.active").length;
            totalFilters += document.querySelectorAll("#collectionSortMobileGems > div.active").length;
            totalFilters += (mobileSlider.get()[0] == mobileSlider.options.range.min && mobileSlider.get()[1] == max) ? 0 : 1;
        } else if (collectionType == "broad") {
            totalFilters = document.querySelectorAll("#collectionSortMobileCategory > div.active").length;
            totalFilters += document.querySelectorAll("#collectionSortMobileColor > div.active").length;
            totalFilters += document.querySelectorAll("#collectionSortMobileGems > div.active").length;
            totalFilters += (mobileSlider.get()[0] == min && mobileSlider.get()[1] == max) ? 0 : 1;
        }

        if (totalFilters == 0) {
            document.querySelector("#collectionSortMobileCancel").textContent = `Clear`;
        } else {
            document.querySelector("#collectionSortMobileCancel").textContent = `Clear (${totalFilters})`;
        }

        //update product count
        if (collectionType == "") {
            document.querySelector("#collectionSortMobileCount").textContent = `${filterProducts(productsAll, true)} Products`;
        } else if (collectionType == "broad") {
            document.querySelector("#collectionSortMobileCount").textContent = `${filterProducts(products, true)} Products`;
        }
    }


    //Check for active subc ategories
    let element = document.querySelector("#collectionSortMobileCategory > div.active");
    if (collectionType == "" && element) {
        //check if there is a subcategory is needed
        if (element.textContent == "Earrings") {
            document.querySelector("#collectionSortMobileEarrings").classList.add("active");
        } else if (element.textContent == "Necklaces") {
            document.querySelector("#collectionSortMobileNecklaces").classList.add("active");
        } else if (element.textContent == "Rings") {
            document.querySelector("#collectionSortMobileRings").classList.add("active");
        } else if (element.textContent == "Chains") {
            document.querySelector("#collectionSortMobileChains").classList.add("active");
        } else if (element.textContent == "Bracelets") {
            document.querySelector("#collectionSortMobileBracelets").classList.add("active");
        }
    }


}

/******************
 Append collection of products
 ******************/
function appendProducts(productsIn) {
    //hide everything
    document.querySelector("#collectionLoader").classList.remove("active");
    document.querySelector("#collectionEmpty").classList.remove("active");
    document.querySelector("#collectionItems").classList.remove("active");
    document.querySelector("#paginateCollection").classList.remove("active");

    //reset data
    document.querySelector("#collectionItems").innerHTML = "";
    document.querySelector("#paginateCollection").innerHTML = "";

    //check if there are no products
    if (productsIn.length == 0) {
        document.querySelector("#collectionEmpty").classList.add("active");

    } else {

        document.querySelector("#collectionItems").classList.add("active");
        document.querySelector("#paginateCollection").classList.add("active");

        //figure out page
        let minProducts = page * 32 - 32;
        let maxProducts = (page * 32 > productsIn.length) ? productsIn.length : page * 32;

        for (let i = minProducts; i < maxProducts; i++) {
            // append ad if index matchs
            collectionAds.forEach(function (ad) {
                if (ad.fixed_position === i || (i > 1 && i % ad.repeat_every === 0)) {
                    document.querySelector("#collectionItems").insertAdjacentHTML("beforeend", `
                        <a class="collectionAd" href="${ad.url}">
                            <img class="collectionAdImage" src="${ad.image_url}">
                        </a>
                   `);
                }


            });

            // append product
            appendProduct("#collectionItems", productsIn[i]);
        }

        //add pages
        let neededPages = Math.ceil(productsIn.length / 32);
        //if there are less than 5 pages, it just lists them out
        if (neededPages > 1 && neededPages < 5) {
            for (let i = 0; i < neededPages; i++) {
                if (i == page - 1) {
                    document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="current goToPage">${i + 1}</span>`);
                } else {
                    document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">${i + 1}</span>`);
                }
            }
        } else if (neededPages >= 5) {
            //we need to establish what page we are on to figure out what layout works best
            //beginning few pages
            if (page < 3) {
                for (let i = 0; i < 3; i++) {
                    if (i == page - 1) {
                        document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="current goToPage">${i + 1}</span>`);
                    } else {
                        document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">${i + 1}</span>`);
                    }
                }
                //add ...
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="deco">...</span>`);
                //add last page
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">${neededPages}</span>`);
            }

            //middle pages
            else if (page - 2 > 0 && page + 1 < neededPages) {
                //add first page
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">1</span>`);
                //add ...
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="deco">...</span>`);
                //add before current page
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">${page - 1}</span>`);
                //add current page
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="current goToPage">${page}</span>`);
                //add after current page
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">${page + 1}</span>`);
                //add ...
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="deco">...</span>`);
                //add last page
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">${neededPages}</span>`);
            }

            //the end
            else {
                //add first page
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">1</span>`);
                //add ...
                document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="deco">...</span>`);
                //now a few if statemetes and we're done
                if (neededPages == page + 2) {
                    document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="current goToPage">${neededPages - 2}</span>`);
                } else {
                    document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">${neededPages - 2}</span>`);
                }

                if (neededPages == page + 1) {
                    document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="current goToPage">${neededPages - 1}</span>`);
                } else {
                    document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">${neededPages - 1}</span>`);
                }

                if (neededPages == page) {
                    document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="current goToPage">${neededPages}</span>`);
                } else {
                    document.querySelector("#paginateCollection").insertAdjacentHTML("beforeend", `<span class="goToPage">${neededPages}</span>`);
                }

            }

        }

        //add event listeners for pages
        document.querySelectorAll("#paginateCollection > span.goToPage").forEach(function (element) {
            element.addEventListener("click", async function () {
                //update page number
                page = parseInt(this.textContent);
                //update page number in current hash
                let newFilters = JSON.parse(decodeURIComponent(window.location.hash.substring(1)));
                newFilters.page = page;
                window.location.hash = encodeURIComponent(JSON.stringify(newFilters));
                //append products
                appendProducts(productsIn);

                // wait 100ms
                await new Promise(r => setTimeout(r, 50));

                //scroll to top
                window.scroll({
                    top: 0,
                    behavior: 'smooth'
                });

            });
        });

    }

    //lastly update mobile count
    document.querySelector("#collectionSortMobileCount").textContent = `${productsIn.length} Products`;

}

/******************
 Fetch collcetion
 ******************/
let products = [];
let desktopSlider, mobileSlider;
let min, max;
let page = 1;
let savedFilters = false;
downloadWishlist()
    .then(async function () {

        // fetch products
        products = await getAllCollectionProducts(collectionHandle);

        if (products.length == 0) {
            document.querySelector("#collectionLoader").classList.remove("active");
            document.querySelector("#collectionEmpty").classList.add("active");
            return;
        }

        //check if this is the shop all collection
        if (collectionTitle == "Shop All") {
            productsAll = products;
        }

        //to setup the range sliders, determine the min and max of this collection
        let productRange = returnMinMax(products);
        min = productRange[0];
        max = productRange[1];

        //initlalize the sliders
        document.querySelectorAll(".priceSlider").forEach(function (element) {
            noUiSlider.create(element, {
                step: 10,
                start: [min, max],
                connect: true,
                tooltips: [
                    wNumb({
                        decimals: 0,
                        prefix: currency
                    }),
                    wNumb({
                        decimals: 0,
                        prefix: currency
                    })
                ],
                range: {
                    'min': min,
                    'max': max
                }
            });
        });
        desktopSlider = document.querySelector("#desktopSlider").noUiSlider;
        mobileSlider = document.querySelector("#mobileSlider").noUiSlider;

        //event listner for sliders
        document.querySelectorAll(".priceSlider").forEach(function (element) {
            element.noUiSlider.on("change", function () {
                //if on desktop changing the slider needs to actually update the products
                if (window.innerWidth > 950) {
                    filterProducts(products);
                }
                updateLabels();
            });
        });

        //check for a filter hash and apply filters
        if (window.location.hash.length > 1) {
            savedFilters = JSON.parse(decodeURIComponent(window.location.hash.substring(1)));
            console.log(savedFilters);
            if (window.innerWidth > 950) {
                //category
                if (savedFilters.category) {
                    savedFilters.category.forEach(function (value) {
                        document.querySelector(`#collectionSortCategoryDropdown > div[value='${value}']`).classList.add("active");
                    });
                }
                //sub
                savedFilters.subcategory.forEach(function (value) {
                    document.querySelector(`.collectionSortSubcategory div[value='${value}']`).classList.add("active");
                });
                //color
                savedFilters.color.forEach(function (value) {
                    document.querySelector(`#collectionSortColorSelector > div[value="${value}"]`).classList.add("active");
                });
                //gem
                savedFilters.gem.forEach(function (value) {
                    document.querySelector(`#collectionSortGemDropdown > div[value="${value}"]`).classList.add("active");
                });
                //in stock only
                if (savedFilters.inStockOnly == true) {
                    document.querySelector("#collectionSortInStock > input").checked = true;
                }
                //sort by
                if (savedFilters.sortBy == "LH") {
                    document.querySelector(`#collectionSortByDropdown > [value="LH"]`).classList.add("active");
                } else if (savedFilters.sortBy == "HL") {
                    document.querySelector(`#collectionSortByDropdown > [value="HL"]`).classList.add("active");
                }
                //price range
                desktopSlider.set(savedFilters.range);
            } else {
                //category
                if (savedFilters.category) {
                    savedFilters.category.forEach(function (value) {
                        document.querySelector(`#collectionSortMobileCategory > div[value='${value}']`).classList.add("active");
                    });
                }
                //sub
                savedFilters.subcategory.forEach(function (value) {
                    document.querySelector(`.collectionSortMobileSubcategory div[value='${value}']`).classList.add("active");
                });
                //color
                savedFilters.color.forEach(function (value) {
                    document.querySelector(`#collectionSortMobileColor > div[value="${value}"]`)?.classList.add("active");
                });
                //gem
                savedFilters.gem.forEach(function (value) {
                    document.querySelector(`#collectionSortMobileGems > div[value="${value}"]`).classList.add("active");
                });
                //in stock only
                if (savedFilters.inStockOnly == true) {
                    document.querySelector("#collectionSortMobileInStock").checked = true;
                }
                //sort by
                if (savedFilters.sortBy == "LH") {
                    document.querySelector("#collectionSortMobileSort > select").selectedIndex = 1;
                } else if (savedFilters.sortBy == "HL") {
                    document.querySelector("#collectionSortMobileSort > select").selectedIndex = 2;
                }
                //price range
                mobileSlider.set(savedFilters.range);
            }

            //check for a page nubmer included with the filter
            if (savedFilters.page) {
                page = savedFilters.page;
            }
        }

        setupFilters();
        updateLabels();
        filterProducts(products);

    })

/******************
 Used on normal collection pages
 ******************/
let productsAll = [];
if (collectionType == "" && collectionTitle != "Shop All") {
    getAllCollectionProducts("all")
        .then(data => {
            productsAll = data;
        });
}